import parse, { attributesToProps, Element, HTMLReactParserOptions, Text } from 'html-react-parser'
import { Helmet } from 'react-helmet'

import { CoxThemeClass, LobExperience } from './types'
import { HREF, SEARCH } from '../constants'

export const getFormattedDate = function (dateInMillisecond: any) {
  const date = new Date(dateInMillisecond)
  const year = date.getFullYear().toString()
  const month = (date.getMonth() + 101).toString().substring(1)
  const day = (date.getDate() + 100).toString().substring(1)
  return year + '-' + month + '-' + day
}
export const getThemeClass = function () {
  if (HREF.indexOf(LobExperience.BUSINESS) > -1) {
    return CoxThemeClass.BUSINESS
  } else {
    return CoxThemeClass.RESIDENTIAL
  }
}

export const appendHash = (url: string, anchorId: string) => {
  const isHashUrl = url === '/#' || url === '#'
  const isSameUrl = isHashUrl || HREF.includes(url)
  const searchUrl = isSameUrl ? SEARCH : ''
  let anchorUrl = url + searchUrl + `#${anchorId}`
  if (isHashUrl) {
    anchorUrl = searchUrl + `#${anchorId}`
  }
  if (anchorId) {
    return anchorUrl
  }
  return url
}

const parseScriptOptions = {
  replace: (domNode: Element) => {
    if (domNode.type === 'script') {
      return (
        <Helmet>
          <script {...attributesToProps(domNode.attribs)}>{(domNode?.children[0] as Text)?.data}</script>
        </Helmet>
      )
    }
  }
}

export const customParse = (text: string, parseScript = false) => {
  if (text) {
    if (parseScript) {
      return parse(text, parseScriptOptions as HTMLReactParserOptions)
    } else {
      return parse(text)
    }
  }
  return ''
}

const sortAlphaNum = (argOne: string, argTwo: string) => argOne.localeCompare(argTwo, 'en', { numeric: true })

export const sortArrayByKey = (arrayList: any, key: string) => {
  return arrayList && arrayList.length > 0
    ? arrayList.sort((obj1: any, obj2: any) => {
        return sortAlphaNum(obj1[key], obj2[key])
      })
    : null
}

export const scrollToCarouselElementWithOffset = (e: any, linkUrl: string, tokenAnchor: string) => {
  const elementId = tokenAnchor || e?.target?.getAttribute('href')?.split('#')[1]
  const stickyNav = document?.querySelector('.react-sticky-container.is-sticky')
  const targetElement = document?.querySelector(`[id="${elementId}"]`)
  if (targetElement) {
    const scrollPosition =
      targetElement?.getBoundingClientRect()?.top + window.scrollY - (stickyNav?.getBoundingClientRect()?.height ?? 120)
    window.scrollTo({ top: scrollPosition - 50, behavior: 'smooth' })
  }
}

export function groupBy<T, K extends keyof any>(list: T[], getKey: (item: T) => K): Record<K, T[]> {
  return list.reduce((result, item) => {
    const key = getKey(item)
    if (!result[key]) {
      result[key] = []
    }
    result[key].push(item)
    return result
  }, {} as Record<K, T[]>)
}

export const extractByPropertyNames = (
  data: any[],
  propertyName: string,
  customProperties?: { [key: string]: any }
): any[] => {
  return data.reduce<any[]>((acc, obj) => {
    if (Array.isArray(obj[propertyName])) {
      const updatedObjects = obj[propertyName].map((item: any) => ({
        ...item,
        ...customProperties
      }))
      acc.push(...updatedObjects)
    }
    return acc
  }, [])
}

export const getCommonPropertyValue = (array: any, propertyName: string) => {
  if (array.length === 0) return null

  const firstValue = array[0][propertyName]
  const isCommon = array.every((obj: any) => obj[propertyName] === firstValue)

  return isCommon ? firstValue : null
}
